(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!window.pcpFreeShippingProgressInitialized) {
    window.pcpFreeShippingProgressInitialized = true;

    const formatPcpMoney = (cents, currency) => {
      const locale = document.documentElement.lang || 'de-DE';
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(cents / 100);
    };

    const updatePcpFreeShippingElement = (element, cart) => {
      const threshold = Number(element.dataset.threshold || 6900);
      const total = Number(cart.total_price || 0);
      const remaining = Math.max(threshold - total, 0);
      const progress = Math.min(Math.max((total / threshold) * 100, 0), 100);
      const text = element.querySelector('[data-free-shipping-text]');
      const fill = element.querySelector('[data-free-shipping-fill]');
      const track = element.querySelector('[role="progressbar"]');

      if (text) {
        text.textContent =
          remaining > 0
            ? element.dataset.remainingTemplate.replace(
                '__AMOUNT__',
                formatPcpMoney(remaining, cart.currency)
              )
            : element.dataset.achievedText;
      }

      if (fill) {
        fill.style.setProperty('--pcp-free-shipping-progress', progress + '%');
      }

      if (track) {
        track.setAttribute('aria-valuenow', String(Math.round(progress)));
      }
    };

    window.pcpRefreshFreeShippingProgress = async () => {
      const elements = document.querySelectorAll('[data-free-shipping-progress]');
      if (!elements.length) return;

      try {
        const cartUrl =
          window.routes && window.routes.cart_url
            ? window.routes.cart_url + '.js'
            : '/cart.js';
        const response = await fetch(cartUrl, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;

        const cart = await response.json();
        elements.forEach((element) => updatePcpFreeShippingElement(element, cart));
      } catch {
      }
    };

    document.addEventListener('DOMContentLoaded', window.pcpRefreshFreeShippingProgress);
    document.addEventListener('shopify:section:load', window.pcpRefreshFreeShippingProgress);
  }
  } catch(e) { console.error(e); }
})();

})();
